<script>
import ExcelImportModal from './modals/excel-import';
import CreateWorkOrderModal from '../../shared/modals/create-work-order';

export default {
  components: { ExcelImportModal, CreateWorkOrderModal },
  data() {
    return {
      isOpened: false,
      buttonClass: {
        btnAdd: true,
        'bg-primary': true,
        rotationAnimation: false,
        unrotateAnimation: false,
      },
      listClass: {
        squareList: true,
        'bg-primary': true,
        showAnimation: false,
        hideAnimation: false,
      },
    };
  },
  mixins: [],
  props: {},
  methods: {
    modalClosed() {
      if (this.isOpened) {
        this.toggleButton();
      }
      this.$emit('reload-work-orders');
    },
    toggleButton() {
      this.isOpened = !this.isOpened;
      this.buttonClass.rotationAnimation = this.isOpened;
      this.buttonClass.unrotateAnimation = !this.isOpened;
      this.listClass.showAnimation = this.isOpened;
      this.listClass.hideAnimation = !this.isOpened;
    },
    importExcel() {
      this.$bvModal.show('excel-import-modal');
    },
    createWorkOrder() {
      this.$bvModal.show('create-work-order-modal');
    },
  },
};
</script>

<template>
  <div>
    <div :class="listClass">
      <ul>
        <li @click="createWorkOrder">{{ $t('workOrders.addAWorkOrder') }}</li>
        <li @click="importExcel">{{ $t('workOrders.excelImport') }}</li>
      </ul>
    </div>
    <div :class="buttonClass" @click="toggleButton">
      <i class="fas fa-plus"></i>
    </div>

    <ExcelImportModal @modal-closed="modalClosed()" />
    <CreateWorkOrderModal @modal-closed="modalClosed()" />
  </div>
</template>

<style scoped>
.squareList {
  position: fixed;
  right: 25px;
  bottom: 25px;
  height: 140px;
  width: 300px;
  z-index: 99;
  clip-path: inset(calc(100% - 60px) 0% 0% calc(100% - 60px) round 30px);
}

@keyframes showAnimationKeyframe {
  0% {
    clip-path: inset(calc(100% - 60px) 0% 0% calc(100% - 60px) round 30px);
  }
  100% {
    clip-path: inset(0% 0% 0% 0% round 30px);
  }
}
@keyframes hideAnimationKeyframe {
  0% {
    clip-path: inset(0% 0% 0% 0% round 30px);
  }
  100% {
    clip-path: inset(calc(100% - 60px) 0% 0% calc(100% - 60px) round 30px);
  }
}

.showAnimation {
  animation: showAnimationKeyframe 0.6s forwards;
}
.hideAnimation {
  animation: hideAnimationKeyframe 0.5s forwards;
}

.btnAdd {
  position: fixed;
  right: 25px;
  bottom: 25px;
  height: 60px;
  line-height: 60px;
  width: 60px;
  font-size: 2em;
  font-weight: bold;
  border-radius: 50%;
  color: white;
  text-align: center;
  cursor: pointer;
  z-index: 100;
}

@keyframes rotate {
  0% {
    transform: scale(1) rotate(0deg);
  }
  100% {
    transform: scale(1) rotate(135deg);
  }
}

@keyframes unrotate {
  0% {
    transform: scale(1) rotate(135deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
}

.rotationAnimation {
  animation: rotate 0.6s forwards;
}

.unrotateAnimation {
  animation: unrotate 0.5s forwards;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 15px;
  width: 100%;
  height: 100%;
}

ul li {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  justify-content: center;
  vertical-align: middle;
  color: white;
  cursor: pointer;
}
</style>